import React, { useState, useEffect } from 'react';
import ReactLoading from 'react-loading';
import Field from '../../fields/Field';
import LocalizedMessage from 'react-l10n';
import { getTranslation } from '../../../lang/main';
import useFormState from '../../FormStateHelper';
import { validateForm } from '../../../selectors/defaultSelectors';
import FieldNumber from '../../fields/FieldNumber';
import FieldPassword from '../../fields/FieldPassword';
import FieldEmail from '../../fields/FieldEmail';
import AddressFormFields from '../../common/AddressFormFields';
import AddressGuestFormFields from '../../common/AddressGuestFormFields';

const FORM_LABEL = {
    BusinessName: getTranslation('FIELD.REGISTERED_BUSINESS_NAME'),
    FirstName: getTranslation('FIELD.FIRST_NAME'),
    Surname: getTranslation('FIELD.LAST_NAME'),
    Email: getTranslation('FIELD.EMAIL'),
    ConfirmEmail: getTranslation('FIELD.EMAIL_CONFIRMATION'),
    Phone: getTranslation('FIELD.PHONE'),
    Mobile: getTranslation('FIELD.MOBILE'),
    Fax: getTranslation('FIELD.FAX'),
    Website: getTranslation('FIELD.WEBSITE'),
    Password: getTranslation('FIELD.NEW_PASSWORD'),
    ConfirmPassword: getTranslation('FIELD.NEW_PASSWORD_CONFIRMATION'),
};

function AccountGuestUserInformationForm(props) {
    const {
        data,
        handleFormSubmission,
        checkValidEmail,
        memberType,
        setAddressFormData,
        setFormValid,
        updateField,
        businessAddress,
        handleNewAddressSubmission,
        setIsNewAddressFormValid,
        setGuestFormData,
    } = props;

    const {
        formData,
        bindUpdateFormData,
        bindUpdateGoogleFormData,
        isSubmitting,
        submitForm,
    } = useFormState({
        handleFormSubmission: handleFormSubmission,
        initialFormState: {},
    });
    const [isValidated, setIsValidated] = useState(false);

    let fieldRefs = {};

    const finalFormData = {
        ...data,
        ...formData,
        IsGuestUser: false,
        SkipVerifyEmailRequest: true
    };

    const onFormSubmit = (e) => {
        e.preventDefault();

        submitForm(finalFormData);
    };
    const onUpdatePhone = (e) => {
        const newValue = e.target.value;
        const isValid = /^[0-9]+$/.test(newValue); // Check if the value contains only digits
        // onFieldUpdate(e);
        if (isValid || newValue === '') {
            // Call onFieldUpdate only when the value is valid or empty
            onFieldUpdate(e);
        }
    };
    const onFieldUpdate = (e) => {
        bindUpdateFormData(e);
    };
    const onFieldUpdateEmail = (e) => {
        onFieldUpdate(e);
        checkValidEmail(e);
    };
    const handleFormUpdate = (e) => {
        bindUpdateFormData(e);
    };
    const updateGoogleFormData = (fieldName, value) => {
        bindUpdateGoogleFormData(fieldName, value);
    };

    // Effects
    // --------------------
    // - Validate form
    useEffect(() => {
        setIsValidated(!validateForm(fieldRefs));
        setGuestFormData(finalFormData);

        setFormValid(!validateForm(fieldRefs));
    }, [formData, setFormValid]);


    return (
        <>
            <React.Fragment>
                <div className='card__header'>
                    <span className='card__header-wrapper'>
                        <span className='card__header-icon'>
                            <span className='icon icon-user-details' />
                        </span>
                    </span>
                    <h3 className='heading heading--lv4'>
                        <LocalizedMessage
                            id={'ACCOUNT_HOLDER_INFORMATION_FORM.HEADING'}
                        />
                    </h3>
                </div>
                <form className='form vspace--small' onSubmit={onFormSubmit}>
                    <div className='row'>
                        <div className='col-xs-12  vspace vspace--small'>
                            <Field

                                ref={(r) => (fieldRefs.BusinessName = r)}
                                label={FORM_LABEL['BusinessName']}
                                animatedLabel={FORM_LABEL['BusinessName']}
                                name='BusinessName'
                                value={finalFormData.BusinessName || ''}
                                onChange={onFieldUpdate}
                            />

                            <div className='row row--small'>
                                <div className='col-xs-12 col-sm-6'>
                                    <Field
                                        required
                                        ref={(r) => (fieldRefs.FirstName = r)}
                                        label={FORM_LABEL['FirstName']}
                                        animatedLabel={FORM_LABEL['FirstName']}
                                        name='FirstName'
                                        value={finalFormData.FirstName || ''}
                                        onChange={onFieldUpdate}
                                    />
                                </div>
                                <div className='col-xs-12 col-sm-6'>
                                    <Field
                                        required
                                        ref={(r) => (fieldRefs.Surname = r)}
                                        label={FORM_LABEL['Surname']}
                                        animatedLabel={FORM_LABEL['Surname']}
                                        name='Surname'
                                        value={finalFormData.Surname || ''}
                                        onChange={onFieldUpdate}
                                    />
                                </div>
                            </div>
                            <div className='row row--small'>
                                <div className='col-xs-12 col-sm-6'>
                                    <FieldEmail
                                        required
                                        ref={(r) => (fieldRefs.Email = r)}
                                        label={FORM_LABEL['Email']}
                                        animatedLabel={FORM_LABEL['Email']}
                                        name='Email'
                                        value={finalFormData.Email || ''}
                                        identical={finalFormData.ConfirmEmail}
                                        onChange={onFieldUpdate}
                                        
                                        
                                    />
                                </div>
                                <div className='col-xs-12 col-sm-6'>
                                    <FieldEmail
                                        required
                                        ref={(r) =>
                                            (fieldRefs.ConfirmEmail = r)
                                        }
                                        label={FORM_LABEL['ConfirmEmail']}
                                        animatedLabel={
                                            FORM_LABEL['ConfirmEmail']
                                        }
                                        name='ConfirmEmail'
                                        value={finalFormData.ConfirmEmail || ''}
                                        identical={finalFormData.Email}
                                        onChange={onFieldUpdate}
                                        onBlur={onFieldUpdateEmail}
                                    />
                                </div>
                            </div>
                            <div className='row row--small'>
                                <div className='col-xs-12 col-sm-6'>
                                    <Field
                                        required
                                        ref={(r) => (fieldRefs.Phone = r)}
                                        label={FORM_LABEL['Phone']}
                                        animatedLabel={FORM_LABEL['Phone']}
                                        name='Phone'
                                        value={finalFormData.Phone || ''}
                                        onChange={onUpdatePhone}
                                    />
                                </div>
                                <div className='col-xs-12 col-sm-6'>
                                    <Field
                                        ref={(r) => (fieldRefs.Mobile = r)}
                                        label={FORM_LABEL['Mobile']}
                                        animatedLabel={FORM_LABEL['Mobile']}
                                        name='Mobile'
                                        type='number'
                                        value={finalFormData.Mobile || ''}
                                        onChange={onUpdatePhone}
                                    />
                                </div>
                            </div>

                            <div className='row row--small'>
                                <div className='col-xs-12 col-sm-6'>
                                    <FieldPassword
                                        required={
                                            finalFormData.ConfirmPassword != ''
                                        }
                                        ref={(r) =>
                                            (fieldRefs.ConfirmPassword = r)
                                        }
                                        label={FORM_LABEL['Password']}
                                        animatedLabel={FORM_LABEL['Password']}
                                        name='Password'
                                        value={finalFormData.Password || ''}
                                        identical={
                                            finalFormData.ConfirmPassword
                                        }
                                        onChange={onFieldUpdate}
                                    />
                                </div>
                                <div className='col-xs-12 col-sm-6'>
                                    <FieldPassword
                                        required={finalFormData.Password != ''}
                                        ref={(r) => (fieldRefs.Password = r)}
                                        label={FORM_LABEL['ConfirmPassword']}
                                        animatedLabel={
                                            FORM_LABEL['ConfirmPassword']
                                        }
                                        name='ConfirmPassword'
                                        value={
                                            finalFormData.ConfirmPassword || ''
                                        }
                                        identical={finalFormData.Password}
                                        onChange={onFieldUpdate}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                <AddressGuestFormFields
                    fieldRefs={fieldRefs}
                    formData={formData}
                    setAddressFormData={setAddressFormData}
                    onFieldUpdate={handleFormUpdate}
                    updateGoogleFormData={updateGoogleFormData}
                    setIsNewAddressFormValid={setIsNewAddressFormValid}
                    showPhoneField={true}
                />

            </React.Fragment>
        </>
    );
}

export default AccountGuestUserInformationForm;
